import React from 'react';

import styles from '../../testOverview.scss';
import { t } from '../../../../services/i18nService';
import liveSessioner from '../../../../services/livesession/LiveSessioner';

const GrantHardwareAccessButton = () => {
    const handleGrantHardwareAccess = () => {
        liveSessioner.requestHardwareAccess();
    };

    return (
        <button
            id="grant-hardware-access-button"
            className={`${styles.button} btn`}
            onClick={handleGrantHardwareAccess}
        >
            <i className="fa fa-arrow-right" aria-hidden />
            {t('hardwareAccessCheck.grantAccess')}
        </button>
    );
};

export default GrantHardwareAccessButton;
